/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Per-channel scale reading.
 * 
 * Mirrors `kodiak.kodiak_types.ScaleChannelReading` on the device — keep the
 * class name and field set in sync when the proto dataclass changes. The
 * proto is the source of truth for what's emitted.
 * @export
 * @interface AppModelsDeviceEventScaleChannelReading
 */
export interface AppModelsDeviceEventScaleChannelReading {
    [key: string]: any | any;
    /**
     * 
     */
    rawValue: number;
    /**
     * 
     */
    signedValue: number;
    /**
     * 
     */
    netValue: number;
    /**
     * 
     */
    weightGrams: number;
    /**
     * 
     */
    calibrationSlope: number | null;
    /**
     * 
     */
    calibrationXIntercept: number | null;
}

/**
 * Check if a given object implements the AppModelsDeviceEventScaleChannelReading interface.
 */
export function instanceOfAppModelsDeviceEventScaleChannelReading(value: object): value is AppModelsDeviceEventScaleChannelReading {
    if ((!('rawValue' in (value as Record<string, any>)) && !('raw_value' in (value as Record<string, any>))) || ((value as Record<string, any>)['rawValue'] === undefined && (value as Record<string, any>)['raw_value'] === undefined)) return false;
    if ((!('signedValue' in (value as Record<string, any>)) && !('signed_value' in (value as Record<string, any>))) || ((value as Record<string, any>)['signedValue'] === undefined && (value as Record<string, any>)['signed_value'] === undefined)) return false;
    if ((!('netValue' in (value as Record<string, any>)) && !('net_value' in (value as Record<string, any>))) || ((value as Record<string, any>)['netValue'] === undefined && (value as Record<string, any>)['net_value'] === undefined)) return false;
    if ((!('weightGrams' in (value as Record<string, any>)) && !('weight_grams' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightGrams'] === undefined && (value as Record<string, any>)['weight_grams'] === undefined)) return false;
    if ((!('calibrationSlope' in (value as Record<string, any>)) && !('calibration_slope' in (value as Record<string, any>))) || ((value as Record<string, any>)['calibrationSlope'] === undefined && (value as Record<string, any>)['calibration_slope'] === undefined)) return false;
    if ((!('calibrationXIntercept' in (value as Record<string, any>)) && !('calibration_x_intercept' in (value as Record<string, any>))) || ((value as Record<string, any>)['calibrationXIntercept'] === undefined && (value as Record<string, any>)['calibration_x_intercept'] === undefined)) return false;
    return true;
}

export function AppModelsDeviceEventScaleChannelReadingFromJSON(json: any): AppModelsDeviceEventScaleChannelReading {
    return AppModelsDeviceEventScaleChannelReadingFromJSONTyped(json, false);
}

export function AppModelsDeviceEventScaleChannelReadingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppModelsDeviceEventScaleChannelReading {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'rawValue': json['raw_value'],
        'signedValue': json['signed_value'],
        'netValue': json['net_value'],
        'weightGrams': json['weight_grams'],
        'calibrationSlope': json['calibration_slope'],
        'calibrationXIntercept': json['calibration_x_intercept'],
    };
}

export function AppModelsDeviceEventScaleChannelReadingToJSON(json: any): AppModelsDeviceEventScaleChannelReading {
    return AppModelsDeviceEventScaleChannelReadingToJSONTyped(json, false);
}

export function AppModelsDeviceEventScaleChannelReadingToJSONTyped(value?: AppModelsDeviceEventScaleChannelReading | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'raw_value': value['rawValue'],
        'signed_value': value['signedValue'],
        'net_value': value['netValue'],
        'weight_grams': value['weightGrams'],
        'calibration_slope': value['calibrationSlope'],
        'calibration_x_intercept': value['calibrationXIntercept'],
    };
}

